import { render, staticRenderFns } from "./cityManage.vue?vue&type=template&id=21495113&scoped=true&"
import script from "./cityManage.vue?vue&type=script&lang=js&"
export * from "./cityManage.vue?vue&type=script&lang=js&"
import style0 from "./cityManage.vue?vue&type=style&index=0&id=21495113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21495113",
  null
  
)

export default component.exports